import api from '../../../services/api';

export const baseURL = process.env.REACT_APP_FAST_FOOD_SERVICE;

// Los endpoints paginados devuelven {results}; los demás, la lista directa
export const asList = (data) => (Array.isArray(data) ? data : data?.results || []);

export const puntosApi = {
    summary: () => api.get('/api/loyalty/summary/', { baseURL }),
    rewards: () => api.get('/api/loyalty/rewards/', { baseURL }),
    saveReward: (id, formData) => (id
        ? api.patch(`/api/loyalty/rewards/${id}/`, formData, { baseURL, headers: { 'Content-Type': 'multipart/form-data' } })
        : api.post('/api/loyalty/rewards/', formData, { baseURL, headers: { 'Content-Type': 'multipart/form-data' } })),
    deleteReward: (id) => api.delete(`/api/loyalty/rewards/${id}/`, { baseURL }),
    redemptions: (params) => api.get('/api/loyalty/redemptions/', { baseURL, params }),
    lookup: (cedula) => api.get('/api/loyalty/customers/lookup/', { baseURL, params: { cedula } }),
    adjustPoints: (data) => api.post('/api/loyalty/adjustments/', data, { baseURL }),
    history: (params) => api.get('/api/loyalty/history/', { baseURL, params }),
    products: () => api.get('/api/menu/products/', { baseURL, params: { is_active: true } }),
    promotions: () => api.get('/api/menu/combos/', { baseURL, params: { is_promotion: true } }),
    patchProduct: (id, data) => api.patch(`/api/menu/products/${id}/`, data, { baseURL }),
    patchPromotion: (id, data) => api.patch(`/api/menu/combos/${id}/`, data, { baseURL }),
};

export const fmtDateTime = (iso) => new Date(iso).toLocaleString('es-EC', { dateStyle: 'short', timeStyle: 'short' });

export const cardStyle = {
    background: '#fff',
    borderRadius: '14px',
    padding: '1.25rem',
    boxShadow: '0 4px 16px rgba(100, 16, 14, 0.06)',
    border: '1px solid #f3e3e3',
};

export const pillStyle = {
    background: 'var(--secondary-color)',
    color: 'var(--primary-color)',
    borderRadius: '999px',
    padding: '2px 10px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
};
